import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);
Chart.defaults.font.size = 18;
Chart.defaults.color = "#ADB5BD";

var xValues = ["2021", "2022", "2023", "2024", "2025"];
var yValues = [12.04, 12.74, 12.83, 13.54, 14];
var barColors = ["#b7b7b7", "#b7b7b7", "#b7b7b7", "#b7b7b7", "#ffffff"];
var xColors = ["#b7b7b7", "#b7b7b7", "#b7b7b7", "#b7b7b7", "#ffffff"];

new Chart("myChart", {
  type: "bar",
  data: {
    labels: xValues,
    datasets: [
      {
        backgroundColor: barColors,
        data: yValues,
      },
    ],
  },

  options: {
    // Remove the legend
    plugins: {
      legend: {
        display: false, // Disable legend
      },
      datalabels: {
        display: true, // Always show data labels on bars
        anchor: "end",
        align: "end",
        offset: -80,
        color: "#99002D", // Data label text color

        font: function (context) {
          if (window.innerWidth >= 1400) {
            return {
              family: "MyriadProBlack",
              size: 26,
              weight: "bold",
            };
          } else if (window.innerWidth >= 1200) {
            return {
              family: "MyriadProBlack",
              size: 20,
              weight: "bold",
            };
          } else if (window.innerWidth >= 768) {
            return {
              family: "MyriadProBlack",
              size: 18,
              weight: "bold",
            };
          } else {
            return {
              family: "MyriadProBlack",
              size: 15,
              weight: "bold",
            };
          }
        },

        formatter: (value) => `$${value.toFixed(2) + "M"}`,
      },
    },

    scales: {
      x: {
        grid: {
          display: false, // Disable X-axis grid lines
        },
        border: {
          display: false,
        },
        ticks: {
          font: function (context) {
            if (window.innerWidth >= 1200) {
              return {
                family: "MyriadProBlack",
                size: 32,
                weight: "bold",
              };
            } else {
              return {
                family: "MyriadProBlack",
                size: 15,
                weight: "bold",
              };
            }
          },
          color: function (context) {
            // Apply the corresponding color from the xColors array
            return xColors[context.index];
          },
        },
      },
      y: {
        grid: {
          display: false, // Disable Y-axis grid lines
        },
        border: {
          display: false,
        },
        beginAtZero: true,

        ticks: {
          display: false, // Hide X-axis labels
        },
      },
    },
  },
});
